import React, { Fragment, useEffect } from 'react';

import { Alert } from 'antd';

import dayjs from 'dayjs';
import { makeCpf } from 'lib/helpers/Domain.helper';
import { useGuestsLogs } from 'lib/providers/GuestsLogsContextProvider';

import './GuestsLogsList.css';

export function GuestsLogsVehicleAlertCard() {
    const { guestsLogs } = useGuestsLogs();
    const [alerts, setAlerts] = React.useState<React.ReactNode[]>([]);

    const playBeep = () => {
        const context = new window.AudioContext();
        const oscillator = context.createOscillator();
        const gain = context.createGain();

        oscillator.type = 'sine';
        oscillator.connect(gain);
        gain.connect(context.destination);

        let time = context.currentTime;
        const duration = 4; // duração da sirene em segundos

        // Cria o efeito de sirene (subindo e descendo a frequência)
        for (let i = 0; i < duration; i += 0.5) {
            oscillator.frequency.linearRampToValueAtTime(800, time + i);
            oscillator.frequency.linearRampToValueAtTime(400, time + i + 0.25);
        }

        gain.gain.setValueAtTime(0.1, time); // volume baixo para não assustar
        oscillator.start(time);
        oscillator.stop(time + duration);
    };

    const alertForVehicleInCondominium = React.useCallback(() => {
        const vehiclesInCondominium = guestsLogs.filter(log => {

            return (
                log.vehicle !== null &&
                log.exited_at === null &&
                dayjs(log.entered_at).format('DD/MM/YYYY') === dayjs().format('DD/MM/YYYY')
                && dayjs().diff(dayjs(log.entered_at), 'minute') >= 15
            );
        }
        );

        setAlerts([]);

        vehiclesInCondominium.forEach(log => {
            const vehicle = log.vehicle;
            const guest = log.guest;

            if (vehicle !== null) {
                if (log.reason !== 'Atendimento RGE' && log.reason !== 'Mudança' && log.reason !== 'Atendimento médico (ambulância, SAMU)') {
                    playBeep();
                }
                setAlerts(prevAlerts => [...prevAlerts, <Alert message='Atenção' description={`O veículo ${vehicle.plate.toUpperCase()} do visitante ${guest.name} (${makeCpf(guest.cpf)}) está no condomínio há mais de 15 minutos.`} banner />]);
            }

        });
    }, [guestsLogs]);

    useEffect(() => {

        alertForVehicleInCondominium();

        const interval = setInterval(() => {
            alertForVehicleInCondominium();
        }, 60000);

        return () => {
            clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guestsLogs]);


    return (
        <div className="guests-logs-list">
            <div className="guests-logs-list__alerts">
                {alerts.map((alert, index) => (
                    <Fragment key={index}>
                        {alert}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
